import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const DrawResponsePreview = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  position: relative;
  max-height: ${rem(400)};
  width: 100%;
`;
